import { Component, OnInit, Inject  } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/services/globals';


@Component({
  selector: 'app-custom-spinner',
  templateUrl: './custom-spinner.component.html',
  styleUrls: ['./custom-spinner.component.css']
})
export class CustomSpinnerComponent implements OnInit {
showDelayText = false;
projectCall = false;
constructor(private translate: TranslateService, private globals: Globals ) { }

  ngOnInit() {
this.showDelayText = this.globals.showLoaderText;
this.projectCall = this.globals.showprojectText;
  }
}
